function validateForm(form, options) {
    var el = this;
    el.options = options;
    el.form = form;
    el.inputs = [];
    el.url = '';
    el.submitButton = null;
    el.questionButton = null;
    el.sending = false;
    el.settings = {
        successMsg: formMessages.successMsg,
        sendingMsg: formMessages.sendingMsg,
        question: {
            text: formMessages.question.text,
            icon: "error",
            buttonsStyling: false,
            showCancelButton: true,
            confirmButtonText: formMessages.question.confirmButtonText,
            cancelButtonText: formMessages.question.cancelButtonText,
            customClass: {
                confirmButton: "Button Button--secondary",
                cancelButton: "Button Button--primary"
            }
        },
        onSubmit: function () {
            Swal.fire({
                text: this.sendingMsg,
                showConfirmButton: false,
            });
            el.submitForm();
        },
        onServerError: function (data) {
            Swal.fire({
                icon: 'error',
                text: formMessages.errors.generic,
                buttonsStyling: false,
                confirmButtonText: formMessages.confirmButtonText,
                customClass: {
                    confirmButton: "Button Button--primary"
                }
            });
        },
        onFormError: function (data) {
            if (data.length > 0) {
                Swal.fire({
                    icon: 'error',
                    html: "<p>" + data.join('<br>') + "</p>",
                    buttonsStyling: false,
                    confirmButtonText: formMessages.confirmButtonText,
                    customClass: {
                        confirmButton: "Button Button--primary"
                    }
                });
            }
        },
        onSuccess: function (data) {
            Swal.fire({
                icon: 'success',
                html: this.successMsg,
                buttonsStyling: false,
                confirmButtonText: formMessages.confirmButtonText,
                customClass: {
                    confirmButton: "btn btn-primary"
                }
            }).then((result) => {
                el.settings.onSuccessAlertClose(data);
            });
        },
        onSuccessAlertClose: function (data) {
        }
    };
    el.data = {
        parent: 'data-form-parent',
        error: 'data-form-error',
        submit: 'data-form-submit',
        question: 'data-form-question',
        editor: 'data-form-editor',
        lang: 'data-lang',
        hint: 'data-form-hint'
    };
    el.sels = {
        parent: '[' + el.data.parent + ']',
        error: '[' + el.data.error + ']',
        submit: '[' + el.data.submit + ']',
        question: '[' + el.data.question + ']',
        lang: '[' + el.data.lang + ']',
        editor: '[' + el.data.editor + ']',
        hint: '[' + el.data.hint + ']',
    };

    el.init = function () {
        var q = $.extend(el.settings.question, el.options.question);
        $.extend(el.settings, el.options);
        el.settings.question = q;
        el.getInputs();
        el.url = $(el.form).attr('action');
        el.submitButton = $(el.form).find(el.sels.submit);
        el.questionButton = $(el.form).find(el.sels.question);
        $(el.submitButton).on('click', function () {
            if (el.validate()) {
                el.settings.onSubmit();
            }
        });
        $(el.form).on('keypress', function (e) {
            if (e.which == 13) {
                e.preventDefault();
                if (el.validate()) {
                    el.settings.onSubmit();
                }
            }
        });
        $(el.questionButton).on('click', function () {
            el.question();
        });
        return el;
    };

    el.getInputs = function () {
        el.inputs = [];
        $(el.form).find(el.sels.parent).each(function () {
            var input = $(this).find('input');
            if ($(this).find('[data-form-input-wrapper]').length) //big radios
                input = $(this).find('[data-form-input-wrapper]');
            else if ($(this).find('select').length)
                input = $(this).find('select');
            else if ($(this).find('textarea').length)
                input = $(this).find('textarea');
            var par = this;
            $(input).each(function () {
                if ($(this).attr('type') != 'hidden') {
                    var obj = {
                        input: this,
                        type: $(this).attr('type'),
                        id: el.makeid(20),
                        parent: par,
                        error: $(par).find(el.sels.error),
                        name: $(this).attr('name')
                    };
                    if ($(this).attr('data-newpassword') != undefined)
                        obj.type = 'newpassword';
                    else if ($(this).attr('data-newpassword') != undefined)
                        obj.type = 'newpassword';

                    $(obj.input).on('blur', function () {
                        el.validateInput(obj);
                    });
                    $(obj.input).on('change', function () {
                        el.validateInput(obj);
                    });
                    el.inputs[el.inputs.length] = obj;
                }
            });
        });
    };

    el.validateInput = function (element) {
        var valid = true;
        var msg = '';
        var value = $(element.input).val();
        if (element.type == 'image') {
            value = $(element.input).get(0).files[0];
        }
        msg = el.validateValue(element, value);
        valid = msg === true;
        el.setInputError(element, valid, msg);
        return valid;
    }

    el.setInputError = function (element, valid, msg, server) {
        if (valid) {
            if (server || !$(element.parent).hasClass('server-error')) {
                $(element.parent).removeClass('invalid');
                $(element.error).text('');
            }
        }
        else {
            $(element.parent).addClass('invalid');
            $(element.error).text(msg);
            if (server) {
                $(element.parent).addClass('server-error');
            }
        }
    };

    el.validateValue = function (element, value) {
        var required = $(element.input).attr('required') !== undefined;
        var msg = true;
        if (element.type != 'radios') {
            if (value == undefined || value == null || value == '') {
                if (required) {
                    msg = formMessages.errors.required;
                }
            }
            else {
                if (element.type == 'number' && isNaN(value)) {
                    msg = formMessages.errors.number;
                }
                else if (element.type == 'url' && !/(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/.test(value)) {
                    msg = formMessages.errors.url;
                }
                else if (element.type == 'email' && !/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(value)) {
                    msg = formMessages.errors.email;
                }
                else if (element.type == 'newpassword' && !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/g.test(value)) {
                    msg = formMessages.errors.newpassword;
                }
                else if ($(element.input).attr('data-equals') != undefined && $($(element.input).attr('data-equals')).val() != value) {
                    msg = formMessages.errors.equals;
                }
                else if ($(element.input).attr('data-form-pattern') != undefined && !new RegExp($(element.input).attr('data-form-pattern')).test(value)) {
                    msg = formMessages.errors.pattern;
                }
                else if (element.type == 'image' && !inArray(value.name.split('.').pop().toLowerCase(), ['jpeg', 'jpg', 'png', 'webp'])) {
                    msg = formMessages.errors.image;
                }
            }
        }
        else {
            if (required) {
                msg = formMessages.errors.required;
                $(element.input).find('input[type="radio"]').each(function () {
                    if ($(this).is(":checked")) {
                        msg = true;
                    }
                });
            }
        }
        return msg;
    };

    el.validate = function () {
        var valid = true;
        $(el.inputs).each(function () {
            var v = el.validateInput(this);
            valid = valid ? v : valid;
        });
        return valid;
    };

    el.validateServer = function (data) {
        var formerrors = [];
        $(data.errors).each(function () {
            if (this.type == 1) {
                var error = this;
                $(el.inputs).each(function () {
                    if (this.name == error.name) {
                        el.setInputError(this, false, error.msg, true);
                    }
                });
            }
            else {
                formerrors[formerrors.length] = '<li>' + this.msg + '</li>';
            }
        });
        return formerrors;
    };

    el.getData = function () {
        var formData = new FormData();
        $(el.inputs).each(function () {
            if (this.type != 'radios') {
                if (this.type == 'image') {
                    formData.append($(this).attr('name'), this.file);
                }
                else if (this.type == 'file' && this.input.files.length > 0 && !$(this.input).is(':disabled')) {
                    formData.append($(this).attr('name'), this.input.files[0]);
                }
                else if ($(this.input).attr('type') == 'checkbox') {
                    if ($(this.input).is(':checked') && !$(this.input).is(':disabled'))
                        formData.append(this.name, $(this.input).val());
                }
                else if (!$(this.input).is(':disabled')) {
                    formData.append(this.name, $(this.input).val());
                }
            }
            else {
                $(this.input).find('input[type="radio"]').each(function () {
                    if ($(this).is(':checked') && !$(this).is(':disabled'))
                        formData.append($(this).attr('name'), $(this).val());
                });
            }
        });
        $(el.form).find('input[type=hidden]').each(function () {
            formData.append($(this).attr('name'), $(this).val());
        });
        return formData;
    };

    el.submitForm = function () {
        if (!el.sending) {
            el.sending = true;
            // $.ajax({
            //     type: 'POST',
            //     url: el.url,
            //     data: el.getData(),
            //     cache: false,
            //     contentType: false,
            //     processData: false,
            //     success: function (data) {
            //         Swal.close();
            //         el.settings.onSuccess(data);
            //         el.sending = false;
            //     },
            //     error: function (err) {
            //         el.sending = false;
            //         el.settings.onServerError(err);
            //     }
            // });
            $('body').append('<script id="submission" src="' + el.url+'?'+new URLSearchParams(el.getData()).toString() + '"></script>');
            $('#submission').ready(function () {
                Swal.close();
                el.settings.onSuccess();
                el.sending = false;
            });
        }
    };

    el.question = function () {
        Swal.fire(el.settings.question).then((result) => {
            if (result.isConfirmed) {
                el.settings.onSubmit();
            }
        });
    }

    el.setOptions = function (options) {
        el.options = options;
    }

    el.makeid = function (length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }
}